import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const getBaseUrl = () => {
  if (typeof window === 'undefined') return '/api/';
  const port = process.env.REACT_APP_DEV_API_SERVER_PORT;
  if (process.env.NODE_ENV === 'development' && port) {
    return `http://localhost:${port}/api/`;
  }
  return '/api/';
};

/**
 * RTK Query API for submitting reports against listings or users. Both
 * endpoints hit the same `POST /api/report` BFF route: they're separate
 * mutations only so the auto-generated hooks have clean, type-safe args.
 *
 *   useReportListingMutation()  → submit({ listingId, reason, details? })
 *   useReportUserMutation()     → submit({ userId,    reason, details? })
 */
export const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl(),
    credentials: 'include',
  }),
  endpoints: build => ({
    reportListing: build.mutation({
      query: ({ listingId, reason, details }) => ({
        url: 'report',
        method: 'POST',
        body: { targetType: 'listing', targetId: listingId, reason, details },
      }),
    }),
    reportUser: build.mutation({
      query: ({ userId, reason, details }) => ({
        url: 'report',
        method: 'POST',
        body: { targetType: 'user', targetId: userId, reason, details },
      }),
    }),
  }),
});

export const { useReportListingMutation, useReportUserMutation } = reportApi;

export default reportApi.reducer;
